module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Robin Rainbow")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    staticStyle: {
      "font-style": "normal",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    staticStyle: {
      "font-style": "normal",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    staticStyle: {
      "font-style": "normal",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    staticStyle: {
      "font-style": "normal",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    staticStyle: {
      "font-style": "normal",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch005#synopsis"
    }
  }, [_vm._v("Synopsis")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    staticStyle: {
      "font-style": "normal",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch006#part-one"
    }
  }, [_vm._v("Part One")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#chapter-1-robin-rainbow-at-home"
    }
  }, [_vm._v("Chapter 1 Robin Rainbow at Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0002#chapter-2-before-the-beginning"
    }
  }, [_vm._v("Chapter 2 Before the Beginning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0003#chapter-3-the-krypton-kid"
    }
  }, [_vm._v("Chapter 3 The Krypton Kid")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0004#chapter-4-robin-meets-conchita"
    }
  }, [_vm._v("Chapter 4 Robin Meets Conchita")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0005#chapter-5-robins-famous-story",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 Robin’s Famous Story")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0006#chapter-6-robins-neighbours-the-mcbrides",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 Robin’s Neighbours the McBrides")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0007#chapter-7-the-storm-that-wasnt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 The Storm that Wasn’t")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#chapter-8-robins-amazing-dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 Robin’s Amazing Dream")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0009#chapter-9-the-discovery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 The Discovery")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0010#chapter-10-the-world-beneath-our-feet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 The World Beneath our Feet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#chapter-11-the-magic-ring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 The Magic Ring")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0012#chapter-12-zodiac-land-is-real",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 Zodiac-Land is Real")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#chapter-13-an-unforgettable-coincidence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 An Unforgettable Coincidence")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0014#chapter-14-robins-daring-prank",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 Robin’s Daring Prank")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0015#chapter-15-evil-forces-at-work",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 Evil Forces at Work")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch007#part-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0016#chapter-16-a-new-adventure-begins",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 A New Adventure Begins")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0017#chapter-17-like-thieves-in-the-night",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 Like Thieves in the Night")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0018#chapter-18-a-novel-within-a-novel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 A Novel within a Novel")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0019#chapter-19-captivity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19 Captivity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0020#chapter-20-childrens-hearts-for-sunday-roast",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 Children’s Hearts for Sunday Roast")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0021#chapter-21-the-thirst-for-freedom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21 The Thirst for Freedom")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0022#chapter-22-havoc-at-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22 Havoc at Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0023#chapter-23-things-could-not-be-worse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23 Things Could Not Be Worse!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0024#chapter-24-do-or-die",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24 Do or Die!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0025#chapter-25-send-them-to-ub-313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25 Send Them to UB 313")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0026#chapter-26-homecoming-or-down-to-earth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26 Homecoming or Down to Earth")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0